/*
	Defines the API route we are using.
*/
var api_url = "",
  web_url = "",
  node_url = "",
  serverless_url = "",
  app_token;

/*
  Depending on the environment, define the API URL.
*/
switch (process.env.NODE_ENV) {
  case "development":
    api_url = "https://pitrack.pilote.immo/pitrack/apirest.php";
    app_token = "JrPPyJXURC0j2gpHODxl94QYUxaouJ3LMtIhI2pS";
    web_url = "http://192.168.12.102:8080";
    node_url = "http://192.168.12.100:3000";
    serverless_url = "https://clients.pilote.immo/api";

    break;
  case "production":
    api_url = "https://pitrack.pilote.immo/pitrack/apirest.php";
    app_token = "JrPPyJXURC0j2gpHODxl94QYUxaouJ3LMtIhI2pS";
    node_url = "https://clients.pilote.immo";
    serverless_url = "https://clients.pilote.immo/api";
    web_url = "";
    break;
}

/*
  Export the cent URL configuration.
*/
export const PORTAL_CONFIG = {
  API_URL: api_url,
  APP_TOKEN: app_token,
  WEB_URL: web_url,
  NODE_SERVER: node_url,
  SERVERLESS_URL: serverless_url
};
